export const logisticsRoutesKeys = {
  route: {
    simplified: (id: string) => ["logisticsRouteSimplified", id],
  },
};
